import {afterNextRender, Component} from '@angular/core';
import {NavigationStart, Router, RouterOutlet} from '@angular/router';
import {UTMService} from './services/utm.service';
import {TrackerService} from './services/tracker.service';
import {TrackingService} from "./services/tracking.service";
import {Meta, Title} from "@angular/platform-browser";
// import {GTMService} from "./services/GTM.service";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(private utmService: UTMService,
              private trackerService: TrackerService,
              private trackingService: TrackingService,
              private titleService: Title,
              private metaService: Meta,
              // private gtmService: GTMService,
              private router: Router) {
    this.metaService.addTag({name: 'description', charset: 'utf-8', content: $localize `:Meta description of the page@@meta.description:Votre bot voyance`});
    this.titleService.setTitle('Isabella');
    // afterNextRender(() => {
    //   this.gtmService.init()
    // });
    afterNextRender(() => {
      this.trackingService.install();
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.autoManageUTMs(event.url);
        this.autoManageTracker(event.url);
      }
    });
  }

  autoManageUTMs(url: string) {
    const utmList = this.utmService.parseUtmListFromRelativeUrl(url);
    if (utmList) {
      this.utmService.persistUtmList(utmList, false);
    }
  }

  autoManageTracker(url: string) {
    const trackerData = this.trackerService.parseTrackerDataFromRelativeUrl(url);
    if (trackerData) {
      this.trackerService.persistTrackerData(trackerData, false);
    }
  }
}
